<div class="relative w-full" #inputContainer>
  <!-- MAIN INPUT FIELD -->
  <input [type]="type" [disabled]="disabled" [placeholder]="placeholder" [class]="cssClass" [value]="inputValue"
    (input)="onInputChange($event)" (keydown)="onKeyDown($event)" (focus)="onFocus()" #inputField>

  <!-- RESULTS CONTAINER -->
  @if (openResults) {
    <div class="absolute top-[110%] left-0 z-[1] w-full rounded-2xl bg-white shadow-md shadow-fcb-blue-dark/20 max-h-60 overflow-y-scroll no-scrollbar"
      tabindex="-1" role="listbox">
      <ul>
        @for (option of filteredOptions; track option.value) {
          <li (click)="selectOption(option)" (mouseover)="hoverOption(option)"
            class="px-3 py-2 cursor-pointer text-black/70 hover:bg-black/10 font-semibold text-sm"
            [class]="{'bg-black/10': highlightedIndex === filteredOptions.indexOf(option)}" role="option">
            <span>
              {{ option.label }}
            </span>
          </li>
        }
      </ul>
    </div>
  }
</div>